/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Promo_HeadingInputs */

const ja_playdata_home_promo_heading = /** @type {(inputs: Playdata_Home_Promo_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料版 2025年 日本eスポーツレポート`)
};

const en_playdata_home_promo_heading = /** @type {(inputs: Playdata_Home_Promo_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FREE 2025 Japan Esports Report`)
};

/**
* | output |
* | --- |
* | "FREE 2025 Japan Esports Report" |
*
* @param {Playdata_Home_Promo_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_promo_heading = /** @type {((inputs?: Playdata_Home_Promo_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Promo_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_promo_heading(inputs)
	return en_playdata_home_promo_heading(inputs)
});